import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import EmptyList from '../common/emptyOrderList';
import OrderInfo from './orderInfo';

const SPECIAL_TYPE = 'E';

const isSubstituteCancelled = (order) => {
  return Boolean(
    order.orderType === SPECIAL_TYPE &&
    order.observations &&
    order.observations.includes('Anulado automáticamente (sustituto)')
  );
};

const extractChain = (observations) => {
  if (!observations || !observations.includes('Sustitución:')) {
    return [];
  }
  const match = observations.match(/Sustitución: ([^|]+)/u);
  if (!match) {
    return [];
  }
  return match[1].trim().split(' > ');
};

const groupOrders = (orders) => {
  const cancelledOrders = orders.filter(isSubstituteCancelled);
  const finalOrders = orders.filter((o) => !isSubstituteCancelled(o));

  return finalOrders.map((order) => {
    const chain = extractChain(order.observations);
    if (!chain.length) {
      return Object.assign({}, order, {'substitutedOrders': []});
    }

    const substitutedCodes = chain.slice(0, chain.length - 1);

    const relatedCancelled = substitutedCodes.map((code, index) => {
      const cancelledOrder = cancelledOrders.find((c) => c.partCode === code);
      const substituteCode = chain[index + 1];
      return {
        'partCode': code,
        'substituteCode': substituteCode,
        'original': cancelledOrder || null,
      };
    });

    return Object.assign({}, order, {'substitutedOrders': relatedCancelled});
  });
};

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderBody() {
    const {loading, orders} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!orders.length) {
      return (<EmptyList />);
    }

    const grouped = groupOrders(orders);

    return grouped.map((order, index) => {
      return (<OrderInfo element={order} key={index} />);
    });
  }

  render() {
    return (
      <Card raised fluid className='management-detail'>
        <div className='scroll-table'>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Pedido</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Tipo Pedido</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>F. Pedido</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Via Concesionario</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Pedido Proveedor</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Via Proveedor</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Cant. Pedida</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Cant. Atendida</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Agencia</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Usuario</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Referencia</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>ETA Estándar</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>ETA Actualizada</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>OR</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Comentarios</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Observaciones</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Vin</Table.HeaderCell>
                <Table.HeaderCell width='1' textAlign='center'>Acciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderBody()}</Table.Body>
          </Table>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.dealerOrdersManagement.loading,
    'orders': state.dealerOrdersManagement.list,
  };
};

export default connect(mapStateToProps)(Detail);
